import NTopNBottom from '../../components/NTopNBottom'

import navColor from '../../assets/filmstrip/nav/color.png'
import navBg from '../../assets/filmstrip/nav/nav_bg.png'
import navBgFixed from '../../assets/filmstrip/nav/nav_bg_fixed.png'

import far1 from '../../assets/filmstrip/nav/far1.png'
import far1_active from '../../assets/filmstrip/nav/far1_active.png'
import far2 from '../../assets/filmstrip/nav/far2.png'
import far2_active from '../../assets/filmstrip/nav/far2_active.png'
import far3 from '../../assets/filmstrip/nav/far3.png'
import far3_active from '../../assets/filmstrip/nav/far3_active.png'
import son1 from '../../assets/filmstrip/nav/son1.png'
import son1_active from '../../assets/filmstrip/nav/son1_active.png'
import son2 from '../../assets/filmstrip/nav/son2.png'
import son2_active from '../../assets/filmstrip/nav/son2_active.png'
import son3 from '../../assets/filmstrip/nav/son3.png'
import son3_active from '../../assets/filmstrip/nav/son3_active.png'
import son4 from '../../assets/filmstrip/nav/son4.png'
import son4_active from '../../assets/filmstrip/nav/son4_active.png'
import son5 from '../../assets/filmstrip/nav/son5.png'
import son5_active from '../../assets/filmstrip/nav/son5_active.png'
import son6 from '../../assets/filmstrip/nav/son6.png'
import son6_active from '../../assets/filmstrip/nav/son6_active.png'
import son7 from '../../assets/filmstrip/nav/son7.png'
import son7_active from '../../assets/filmstrip/nav/son7_active.png'
import son8 from '../../assets/filmstrip/nav/son8.png'
import son8_active from '../../assets/filmstrip/nav/son8_active.png'
import son9 from '../../assets/filmstrip/nav/son9.png'
import son9_active from '../../assets/filmstrip/nav/son9_active.png'
import bannerImg from '../../assets/filmstrip/banner.png'

import p1_1_1 from '../../assets/filmstrip/ctn/1_1_1.jpg'
import p1_1_2 from '../../assets/filmstrip/ctn/1_1_2.jpg'
import p1_1_3 from '../../assets/filmstrip/ctn/1_1_3.jpg'
import p1_2_1 from '../../assets/filmstrip/ctn/1_2_1.jpg'
import p1_2_2 from '../../assets/filmstrip/ctn/1_2_2.jpg'
import p1_3_1 from '../../assets/filmstrip/ctn/1_3_1.jpg'
import p1_3_2 from '../../assets/filmstrip/ctn/1_3_2.jpg'

import p2_1_1 from '../../assets/filmstrip/ctn/2_1_1.jpg'
import p2_1_2 from '../../assets/filmstrip/ctn/2_1_2.jpg'
import p2_1_3 from '../../assets/filmstrip/ctn/2_1_3.jpg'
import p2_2_1 from '../../assets/filmstrip/ctn/2_2_1.jpg'
import p2_2_2 from '../../assets/filmstrip/ctn/2_2_2.jpg'
import p2_3_1 from '../../assets/filmstrip/ctn/2_3_1.jpg'
import p2_3_2 from '../../assets/filmstrip/ctn/2_3_2.jpg'

import p3_1_1 from '../../assets/filmstrip/ctn/3_1_1.jpg'
import p3_1_2 from '../../assets/filmstrip/ctn/3_1_2.jpg'
import p3_1_3 from '../../assets/filmstrip/ctn/3_1_3.jpg'
import p3_2_1 from '../../assets/filmstrip/ctn/3_2_1.jpg'
import p3_3_1 from '../../assets/filmstrip/ctn/3_3_1.jpg'

import calcRemFn from '../calcRem'

const PROD_ID = '95072'
const BRAND = 'gold'
const navCss = {
  navWrap: {
    minHeight: calcRemFn(133),
    backgroundImage: `url(${navColor})`,
  },
  navCtn: {
    height: calcRemFn(142),
    backgroundImage: `url(${navBg})`,
  },
  navCtnFixed: {
    height: calcRemFn(142),
    backgroundImage: `url(${navBgFixed})`,
  },
  topBtnLayout: {
    padding: `${calcRemFn(14)} ${calcRemFn(6)}`,
    paddingBottom: 0,
    justifyContent: 'space-between'
  },
  topBtnBaseCss: {
    height: calcRemFn(29),
    width: calcRemFn(121)
  },
  bottomBtnLayout: {
    padding: `0 ${calcRemFn(6)}`,
    marginTop: `${calcRemFn(-1)}`
  },
  bottomBtnBaseCss: {
    height: calcRemFn(65),
    width: calcRemFn(121)
  }
}

const navData = {
  component: NTopNBottom,
  top: [
    {
      key: 'top1',
      show: true,
      img: far1,
      img_actived: far1_active,
    },
    {
      key: 'top2',
      show: true,
      img: far2,
      img_actived: far2_active,
    },
    {
      key: 'top3',
      show: true,
      img: far3,
      img_actived: far3_active,
    }
  ],
  bottom: {
    top1: [
      {
        key: '_i1',
        show: true,
        img: son1,
        img_actived: son1_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son2,
        img_actived: son2_active,
        prodId: PROD_ID
      },
      {
        key: '_i3',
        show: true,
        img: son3,
        img_actived: son3_active,
        prodId: PROD_ID
      },
    ],
    top2: [
      {
        key: '_i1',
        show: true,
        img: son4,
        img_actived: son4_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son5,
        img_actived: son5_active,
        prodId: PROD_ID
      },
      {
        key: '_i3',
        show: true,
        img: son6,
        img_actived: son6_active,
        prodId: PROD_ID
      },
    ],
    top3: [
      {
        key: '_i1',
        show: true,
        img: son7,
        img_actived: son7_active,
        prodId: PROD_ID
      },
      {
        key: '_i2',
        show: true,
        img: son8,
        img_actived: son8_active,
        prodId: PROD_ID
      },
      {
        key: '_i3',
        show: true,
        img: son9,
        img_actived: son9_active,
        prodId: PROD_ID
      },
    ]
  }
}

const pictures = [
  {
    id: 107275,
    type: BRAND,
    ref: 'top1_i1',
    farName: 'top1',
    sonName: '_i1',
    son: [
      p1_1_1,
      p1_1_2,
      p1_1_3
    ],
    name: '古典-玛德琳'
  },
  {
    id: 107275,
    type: BRAND,
    ref: 'top1_i2',
    farName: 'top1',
    sonName: '_i2',
    son: [
      p1_2_1,
      p1_2_2,
    ],
    name: '古典-仙踪'
  },
  {
    id: 107275,
    type: BRAND,
    ref: 'top1_i3',
    farName: 'top1',
    sonName: '_i3',
    son: [
      p1_3_1,
      p1_3_2
    ],
    name: '甜美-优格'
  },
  {
    id: 107276,
    type: BRAND,
    ref: 'top2_i1',
    farName: 'top2',
    sonName: '_i1',
    son: [
      p2_1_1,
      p2_1_2,
      p2_1_3
    ],
    name: '甜美-可露丽'
  },
  {
    id: 107276,
    type: BRAND,
    ref: 'top2_i2',
    farName: 'top2',
    sonName: '_i2',
    son: [
      p2_2_1,
      p2_2_2,
    ],
    name: '哥特-落影天使'
  },
  {
    id: 107276,
    type: BRAND,
    ref: 'top2_i3',
    farName: 'top2',
    sonName: '_i3',
    son: [
      p2_3_1,
      p2_3_2
    ],
    name: '哥特-月夜舞曲'
  },
  {
    id: 107277,
    type: BRAND,
    ref: 'top3_i1',
    farName: 'top3',
    sonName: '_i1',
    son: [
      p3_1_1,
      p3_1_2,
      p3_1_3
    ],
    name: '甜美-可露丽'
  },
  {
    id: 107277,
    type: BRAND,
    ref: 'top3_i2',
    farName: 'top3',
    sonName: '_i2',
    son: [
      p3_2_1
    ],
    name: '哥特-落影天使'
  },
  {
    id: 107277,
    type: BRAND,
    ref: 'top3_i3',
    farName: 'top3',
    sonName: '_i3',
    son: [
      p3_3_1
    ],
    name: '哥特-月夜舞曲'
  }
]

const topDiff = {
  firstSon: '_i1',
  top1_i1: 10,
  top2_i1: 38,
  top3_i1: 38,
}

export default {
  title: '电影胶片',
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff
}
